/*
 * Copyright © 2017-Present, The Freshwater Trust, all rights reserved.
 */

import React, {useCallback} from 'react';
import {FormLabel} from 'react-bootstrap';
import {Conditional} from "../../Conditional";
import {HelpIcon} from "../HelpIcon";
import {useGenericModelHooks} from "../../../Hooks/GenericModelHooks";
import {useShouldEditField} from "../../../Hooks/GenericModelHooks";

import * as fieldComponents from "../../../Models/Core/FieldComponents";
import {StreamBankListEmptyRow} from "./StreamBankListEmptyRow";

export function ChildModelViewerRecordRenderer(props) {

    const {FieldDef, FieldDefinitionGroups = null, SkipBorder, Data, RootData, OnValidationUpdate, CustomData, IsNewModel} = props;

    const {
        getFieldDefs,
        updateField,
        updateFields,
    } = useGenericModelHooks(props);

    const shouldEditField = useShouldEditField();
    
    const editorComponentOnUpdate = useCallback((y, fieldDef = FieldDef) => updateField(fieldDef, y), [FieldDef, updateField])
    const editorComponentOnUpdates = useCallback((y) => updateFields(y), [updateFields])
    
    const shouldEdit = shouldEditField(props);

    let data = FieldDef.getter(Data);

    const EditorComponent = fieldComponents?.[FieldDef.editor] ?? null;
    const ViewerComponent = fieldComponents?.[FieldDef.viewer] ?? null;

    const RecordComponent = shouldEdit ? EditorComponent : ViewerComponent;

    if(RecordComponent == null) {
        console.log(FieldDef);
        return null;
    }
    
    return <React.Fragment>
        <tr className={"sb-editor-row-" + FieldDef.key}>
            <Conditional Condition={FieldDef.displayLabel}>
                <td className="sb-model-viewer-column">
                    <FormLabel>
                        {FieldDef.title}
                    </FormLabel>
                    <Conditional Condition={shouldEdit && FieldDef.association?.helpText != ""}>
                        <HelpIcon id={"help-icon-" + FieldDef.key}>{FieldDef.association?.helpText}</HelpIcon>
                    </Conditional>
                </td>
            </Conditional>
            <td className="sb-model-viewer-column sb-model-viewer-column-sub-editor"
                colSpan={FieldDef.displayLabel ? 1 : 2}>
                <RecordComponent
                    EditMode={shouldEdit}
                    Value={data}
                    OnUpdate={editorComponentOnUpdate}
                    OnUpdates={editorComponentOnUpdates}
                    FieldDef={FieldDef}
                    RootData={RootData}
                    Data={Data}
                    FieldDefs={ FieldDefinitionGroups ?? getFieldDefs(true)}
                    OnValidationUpdate={OnValidationUpdate}
                    CustomData={CustomData}
                    IsNewModel={IsNewModel}
                    EmptyItemComponent={StreamBankListEmptyRow}
                />
            </td>
        </tr>
        <Conditional Condition={FieldDef.displayLabel && SkipBorder}>
            <tr className="separator">
                <td>
                    <hr/>
                </td>
                <td/>
            </tr>
        </Conditional>
    </React.Fragment>;
}


